import { UserReduxAction } from "gyg_common";
import { store } from "redux_store/configureReduxStore";

/** Check if geolocation is availble in the browser */
export const isGeolocationAvailable = (): boolean => {
  if ("geolocation" in navigator) {
    return true;
  } else {
    return false;
  }
};
export const configureLocationProvider: PositionOptions = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 5000,
};

/** Get the user's location using the geolocation API.
 */
export const getUserLocation = (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    if (isGeolocationAvailable()) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          resolve(position);
        },
        (error) => {
          reject(error);
        },
        configureLocationProvider
      );
    }
  });
};

/** Check the user location permission.
 * 'granted' - user has allowed the browser to provide location info
 * 'prompt' - ask the user to allow the lcoation on next call to get location
 * 'denied' - user has denied permission for location services in the browser
 */
export const getCurrentLocationPermission = (): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (navigator.permissions) {
      navigator.permissions
        .query({
          name: "geolocation",
        })
        .then((permission: PermissionStatus) => {
          if (permission) {
            store.dispatch(
              UserReduxAction.setLocationPermission(
                permission.state === "granted"
              )
            );
          }
          resolve(permission.state === "granted");
        })
        .catch((err) => reject(err));
    } else {
      getUserLocation()
        .then(() => {
          store.dispatch(UserReduxAction.setLocationPermission(true));
          resolve(true);
        })
        .catch(() => {
          store.dispatch(UserReduxAction.setLocationPermission(false));
          reject(false);
        });
    }
  });
};

export const requestLocationPermission = (): Promise<{
  permissionGranted: boolean;
  userLocation: GeolocationPosition;
}> => {
  return new Promise((resolve, reject) => {
    getUserLocation()
      .then((location) => {
        store.dispatch(UserReduxAction.setLocationPermission(true));
        resolve({
          permissionGranted: true,
          userLocation: location,
        });
      })
      .catch((err) => {
        store.dispatch(UserReduxAction.setLocationPermission(false));
        reject(err);
      });
  });
};
